<template>
  <div>
    <div
      :class="{
        active: showList,
        'has-selections': hasSelections,
        'reset-enabled': showReset,
      }"
      class="multiselect boxgroup-parent"
    >
      <label v-if="label" class="label-filters">
        {{ label }}
      </label>
      <div class="multiselect__button-wrapper">
        <button
          v-if="hasSelections && showReset"
          aria-label="Reset this filter"
          class="button reset"
          @click="emitResetFilter"
        >
          <i class="icon">
            <Icon name="fa6-solid:circle-xmark" />
          </i>
        </button>
        <button
          :class="{ 'shows-selections': showSelections }"
          class="button toggle"
          @click="listToggle"
        >
          <span v-if="!showSelections">
            {{ placeholder }}
          </span>
          <span v-else>
            {{ selectedOptions }}
          </span>
          <i class="icon icon--opens">
            <Icon name="fa6-solid:chevron-right" />
          </i>
        </button>
      </div>
      <div class="boxgroup-wrapper">
        <div class="boxgroup-wrapper__scrolling">
          <button class="button return visible-xs" @click="listToggle">
            <i class="icon">
              <Icon name="fa6-solid:chevron-left" />
            </i>
            <span> Return to Filters </span>
          </button>
          <ClientOnly>
            <FormKit
              v-model="valueProxy"
              :options="options"
              fieldset-class="boxgroup"
              label-class="formkit-label--after"
              type="checkbox"
            />
          </ClientOnly>
        </div>
      </div>
      <div class="boxgroup-parent__fill-behind" @click="listToggle" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { VueFormulateSelect } from '~/composables/useVueFormulateSelect'

const emit = defineEmits(['update:modelValue', 'onReset', 'onFilterMounted'])
const props = defineProps<VueFormulateSelect>()
const valueProxy = computed({
  get: () => {
    return props.modelValue
  },
  set: (newValue) => {
    const updatedValue = Array.isArray(newValue) ? newValue : [newValue]
    emit?.('update:modelValue', updatedValue)
  },
})

function emitResetFilter() {
  valueProxy.value = []
}

onMounted(() => {
  nextTick(() => emit('onFilterMounted'))
})

const { showList, hasSelections, listToggle, selectedOptions } =
  useVueFormulateSelect({ ...props, valueProxy })
</script>
